/**
 * Error codes specific to the UserController
 */
export var UserErrorCode;
(function (UserErrorCode) {
    /**
     * Request validation failed in UserRouter.
     */
    UserErrorCode["ValidationFailed"] = "user/ValidationFailed";
    /**
     * Trying to confirm a user with a password that is already confirmed.
     * SetPassword is only used for E2E.
     */
    UserErrorCode["AlreadyConfirmed"] = "user/UserAlreadyConfirmed";
    /**
     * Upstream auth provider (Cognito) limit exceeded, leading to failure of
     * operation.
     */
    UserErrorCode["UpstreamLimitExceeded"] = "user/UpstreamLimitExceeded";
    /**
     * User failed recaptcha validation
     */
    UserErrorCode["FailedRecaptcha"] = "user/FailedRecaptcha";
    /**
     * If the user is the last user/group administrator in a court, they cannot be removed.
     */
    UserErrorCode["UserCannotBeRemovedFromCourtSystems"] = "user/UserCannotBeRemovedFromCourtSystems";
})(UserErrorCode || (UserErrorCode = {}));
